import { privateInstance } from "../configs";

export const tagApi = {
  async getTagCategories() {
    const res = await privateInstance.get("/recipes/api/tag-category/");
    return res.data;
  },
  async postTagCategory(category) {
    const res = await privateInstance.post(
      "/recipes/api/tag-category/",
      category
    );
    return res.data;
  },
  async retrieveTagCategory(id) {
    const res = await privateInstance.get(`/recipes/api/tag-category/${id}/`);
    return res.data;
  },
  async patchTagCategory(id, category) {
    const res = await privateInstance.patch(
      `/recipes/api/tag-category/${id}/`,
      category
    );
    return res.data;
  },
  async deleteTagCategory(id) {
    const res = await privateInstance.delete(
      `/recipes/api/tag-category/${id}/`
    );
    return res.data;
  },
  async getInventoryTagOrders() {
    const res = await privateInstance.get(
      `/recipes/api/inventory/template/order/`
    );
    return res.data;
  },
  async postInventoryTagOrder(data) {
    const res = await privateInstance.post(
      `/recipes/api/inventory/template/order/`,
      data
    );
    return res.data;
  },
  async patchInventoryTagOrder(id, data) {
    const res = await privateInstance.patch(
      `/recipes/api/inventory/template/order/${id}/`,
      data
    );
    return res.data;
  },
  async updateInventoryTagOrderBatch(data) {
    const res = await privateInstance.post(
      `/recipes/api/inventory/template/order/batch/`,
      data
    );
    return res.data;
  }
};
